export const hi = {
	content: `
<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:dt="uuid:C2F41010-65B3-11d1-A29F-00AA00C14882" xmlns="http://www.w3.org/TR/REC-html40">
    <head>
        <meta http-equiv=Content-Type content="text/html; charset=utf-8">
        <meta name=ProgId content=Word.Document>
        <meta name=Generator content="Microsoft Word 14">
        <meta name=Originator content="Microsoft Word 14">
        <link rel=File-List href="Finvu (CTPL)_Terms and Conditions_HI.files/filelist.xml">
        <title>Finvu</title>
        <!--[if gte mso 9]><xml><o:DocumentProperties><o:Author>Rucha Ghude</o:Author><o:LastAuthor>Mukthyar Lukmandin</o:LastAuthor><o:Revision>1</o:Revision><o:Pages>3</o:Pages><o:Characters>22012</o:Characters><o:Lines>183</o:Lines><o:Paragraphs>51</o:Paragraphs></o:DocumentProperties><o:CustomDocumentProperties><o:GrammarlyDocumentId dt:dt="string" >68ffa36e7d9bbf332e92e069fa30ea69ccd30aff8bdce869d49b9b87b83fa573</o:GrammarlyDocumentId><o:KSOProductBuildVer dt:dt="string" >1033-12.2.0.20795</o:KSOProductBuildVer><o:ICV dt:dt="string" >6211F1D90B214FEB82C8246CCC9D1CA7_13</o:ICV></o:CustomDocumentProperties></xml><![endif]-->
        <!--[if gte mso 9]><xml><o:OfficeDocumentSettings></o:OfficeDocumentSettings></xml><![endif]-->
        <!--[if gte mso 9]><xml><w:WordDocument><w:BrowserLevel>MicrosoftInternetExplorer4</w:BrowserLevel><w:DisplayHorizontalDrawingGridEvery>0</w:DisplayHorizontalDrawingGridEvery><w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery><w:DocumentKind>DocumentNotSpecified</w:DocumentKind><w:DrawingGridVerticalSpacing>7.8 磅</w:DrawingGridVerticalSpacing><w:PunctuationKerning></w:PunctuationKerning><w:View>Web</w:View><w:Compatibility><w:DontGrowAutofit/><w:DoNotExpandShiftReturn/></w:Compatibility><w:Zoom>0</w:Zoom></w:WordDocument></xml><![endif]-->
        <!--[if gte mso 9]><xml><w:LatentStyles DefLockedState="false"  DefUnhideWhenUsed="true"  DefSemiHidden="true"  DefQFormat="false"  DefPriority="99"  LatentStyleCount="260" >
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Normal" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="heading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footer" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="35"  SemiHidden="false"  QFormat="true"  Name="caption" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of figures" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope return" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="line number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="page number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of authorities" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="macro" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="toa heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="10"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Title" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Closing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="1"  SemiHidden="false"  Name="Default Paragraph Font" ></w:LsdException>
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Body Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Message Header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="11"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Subtitle" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Salutation" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Date" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Note Heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Block Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Hyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="FollowedHyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="22"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Strong" ></w:LsdException>
<w:LsdException Locked="false"  Priority="20"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Emphasis" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Document Map" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Plain Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="E-mail Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal (Web)" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Acronym" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Cite" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Code" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Definition" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Keyboard" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Preformatted" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Sample" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Typewriter" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Variable" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal Table" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation subject" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / a / i" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / 1.1 / 1.1.1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Article / Section" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Contemporary" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Elegant" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Professional" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Balloon Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Table Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Theme" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Placeholder Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No Spacing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Paragraph" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Intense Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 6" ></w:LsdException>
</w:LatentStyles></xml><![endif]-->
        <style>
            @font-face {
                font-family: "Times New Roman";
            }

            @font-face {
                font-family: "宋体";
            }

            @font-face {
                font-family: "Courier New";
            }

            @font-face {
                font-family: "Wingdings";
            }

            @font-face {
                font-family: "Arial";
            }

            @font-face {
                font-family: "Anek Devanagari";
            }

            @list l0:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l0:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l1:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l2:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l3:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l4:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l5:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l6:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level1 {
                mso-level-start-at: 3;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Times New Roman';
            }

            @list l7:level2 {
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "%1.%2";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Devanagari';
                mso-fareast-font-family: Arial;
                color: rgb(22,28,45);
                letter-spacing: 0.0000pt;
                font-weight: bold;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l7:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l8:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l9:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l10:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l11:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level1 {
                mso-level-start-at: 4;
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l12:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l13:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level1 {
                mso-level-start-at: 2;
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l14:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l15:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l16:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l17:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l18:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level1 {
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "%1.";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(22,28,45);
                letter-spacing: 0.0000pt;
                font-weight: bold;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l19:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l20:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l21:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l22:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l23:level2 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "%1.%2";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Times New Roman';
            }

            @list l23:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            p.MsoNormal {
                mso-style-name: Normal;
                mso-style-parent: "";
                margin: 0pt;
                margin-bottom: .0001pt;
                mso-pagination: none;
                font-family: 'Courier New';
                color: rgb(0,0,0);
                font-size: 12.0000pt;
            }

            span.10 {
                font-family: 'Courier New';
            }

            span.15 {
                font-family: 'Times New Roman';
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 10.0000pt;
            }

            span.16 {
                font-family: Arial;
                color: rgb(22,28,45);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 7.5000pt;
            }

            span.17 {
                font-family: Arial;
                color: rgb(56,76,116);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            span.18 {
                font-family: Arial;
                color: rgb(56,76,116);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            p.19 {
                mso-style-name: "Header or footer \(2\)";
                margin: 0pt;
                margin-bottom: .0001pt;
                mso-pagination: none;
                font-family: 'Times New Roman';
                color: rgb(0,0,0);
                font-size: 10.0000pt;
            }

            p.20 {
                mso-style-name: "Heading \#1";
                margin-top: 29.0000pt;
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                mso-outline-level: 1;
                font-family: Arial;
                color: rgb(22,28,45);
                font-size: 7.5000pt;
            }

            p.MsoBodyText {
                mso-style-name: "Body Text";
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                line-height: 150%;
                font-family: Arial;
                color: rgb(56,76,116);
                font-size: 12.75pt;
            }

            p.22 {
                mso-style-name: Other;
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                line-height: 150%;
                font-family: Arial;
                color: rgb(56,76,116);
                font-size: 12.75pt;
            }

            span.msoIns {
                mso-style-type: export-only;
                mso-style-name: "";
                text-decoration: underline;
                text-underline: single;
                color: blue;
            }

            span.msoDel {
                mso-style-type: export-only;
                mso-style-name: "";
                text-decoration: line-through;
                color: red;
            }

            table.MsoNormalTable {
                mso-style-name: "Table Normal";
                mso-style-parent: "";
                mso-style-noshow: yes;
                mso-tstyle-rowband-size: 0;
                mso-tstyle-colband-size: 0;
                mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
                mso-para-margin: 0pt;
                mso-para-margin-bottom: .0001pt;
                mso-pagination: widow-orphan;
                font-family: 'Times New Roman';
                font-size: 10.0000pt;
                mso-ansi-language: #0400;
                mso-fareast-language: #0400;
                mso-bidi-language: #0400;
            }

            @page {
                mso-page-border-surround-header: no;
                mso-page-border-surround-footer: no;
            }

            @page Section0 {
                margin-top: 27.0000pt;
                margin-bottom: 27.0000pt;
                margin-left: 67.7000pt;
                margin-right: 22.1000pt;
                size: 612.0000pt 792.0000pt;
                layout-grid: 18.0000pt;
                mso-header-margin: 0.0000pt;
                mso-footer-margin: 0.1500pt;
                mso-footer: url("Finvu%20\(CTPL\)_Terms%20and%20Conditions_HI.files/header.html") f0;
            }

            div.Section0 {
                page: Section0;
            }
        </style>
    </head>
    <body style="tab-interval:36pt;text-justify-trim:punctuation;">
        <!--StartFragment-->
        <div class="Section0" style="layout-grid:18.0000pt;">
            <p class=20 align=justify style="margin-top:12.0000pt;margin-right:20.9000pt;page-break-after:avoid;
mso-pagination:lines-together;text-align:justify;text-justify:inter-ideograph;">
                <a name="bookmark0"></a>
                <b>
                    <span class="16" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:22.5000pt;">सेवा की शर्तें</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-size:22.5000pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:12.0000pt;text-align:justify;
text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अपडेट किया गया </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">2-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जनवरी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-2025</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;border-bottom:1.0000pt solid rgb(173,173,173);
mso-border-bottom-alt:0.5000pt solid rgb(173,173,173);padding:0pt 0pt 1pt 0pt ;text-align:justify;
text-justify:inter-ideograph;">
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ये नियम और शर्तें </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">नियम</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") Finvu </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">एप्लिकेशन और वेबसाइट </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्लेटफ़ॉर्म</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और सेवाओं </span>
                <i style="mso-bidi-font-style:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;mso-ansi-font-style:italic;
mso-bidi-font-style:normal;font-variant:normal;font-size:12.75pt;">(</span>
                </i>
                <i>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:italic;
font-variant:normal;font-size:12.75pt;">नीचे परिभाषित</span>
                </i>
                <i style="mso-bidi-font-style:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;mso-ansi-font-style:italic;
mso-bidi-font-style:normal;font-variant:normal;font-size:12.75pt;">)</span>
                </i>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;&nbsp;</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तक पहुंच और उपयोग को नियंत्रित करती हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों में हमारी गोपनीयता नीति भी शामिल है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जो </span>
                <span>
                    <a href="http://www.finvu.in/privacy">
                        <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">www.finvu.in/privacy</span>
                    </a>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">गोपनीयता नीति</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पर उपलब्ध है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और हमारे द्वारा समय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समय पर उपलब्ध कराए गए या जारी किए गए कोई भी दिशानिर्देश</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अतिरिक्त शर्तें</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">नीतियां या अस्वीकरण भी शामिल हैं। इन शर्तों को हमारे द्वारा नीचे दिए गए प्रावधानों के अनुसार संशोधित किया जा सकता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और समय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समय पर संशोधित शर्तें आप पर लागू होंगी। आप प्लेटफ़ॉर्म पर इन शर्तों के वर्तमान संस्करण की हमेशा समीक्षा कर सकते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ये शर्तें </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Cookiejar Technologies Private Limited ("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">कंपनी</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">", "</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">", "</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">Finvu</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">", </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमें</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं के किसी भी प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता और किसी भी वित्तीय सूचना प्रदाता या वित्तीय सूचना प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता जो हमारे </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वातावरण का उपयोग करते हैं </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपका</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">के बीच एक बाध्यकारी और लागू करने योग्य कानूनी अनुबंध का गठन करती हैं। </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Cookiejar Technologies Private Limited </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">को </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">RBI </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">द्वारा लाइसेंस प्राप्त है और उसके पास अकाउंट एग्रीगेटर के रूप में काम करने के लिए </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India (RBI) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">द्वारा दिया गया पंजीकरण प्रमाणपत्र भी है। कंपनी के पास </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अधिनियम</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 1934 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">की धारा </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">45 IA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">के अंतर्गत </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">द्वारा जारी दिनांक </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">06 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मार्च </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">2020 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का वैध पंजीकरण प्रमाणपत्र है। आप प्रतिनिधित्व करते हैं और वारंट करते हैं कि आपके पास </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(a) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों से सहमत होने और खुद को बाध्य करने की पूरी कानूनी क्षमता और अधिकार है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, (b) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि आप एक व्यक्ति हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आपकी आयु अठारह वर्ष या उससे अधिक है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि आप </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">18 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वर्ष से कम उम्र के हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आपको सेवाओं का उपयोग करने के लिए माता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पिता या कानूनी अभिभावक की सहायता लेनी चाहिए और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(c) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">एक भारतीय निवासी हैं। यदि आप किसी संस्था</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">संगठन या किसी अन्य कानूनी व्यक्ति का प्रतिनिधित्व करते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आप पुष्टि करते हैं और प्रतिनिधित्व करते हैं कि आपके पास ऐसी संस्था</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">संगठन या कानूनी व्यक्ति को इन शर्तों से बांधने के लिए आवश्यक शक्ति और अधिकार है।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमारे प्लेटफ़ॉर्म</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का उपयोग करके</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप सहमत होते हैं कि आपने इन शर्तों को पढ़ लिया है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समझ लिया है और इनसे बंधे हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और आप यहाँ सूचीबद्ध आवश्यकताओं का अनुपालन करते हैं। यदि आप इन सभी शर्तों से सहमत नहीं हैं या यहां सूचीबद्ध आवश्यकताओं का अनुपालन नहीं करते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो कृपया प्लेटफ़ॉर्म तक न पहुंचें या सेवाओं और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का उपयोग न करें।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.1000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        1.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">परिभाषाएं</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">AA </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">मास्टर निर्देश</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का अर्थ मास्टर निर्देश </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">- </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">गैर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बैंकिंग वित्तीय कंपनी </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">- </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">खाता एग्रीगेटर </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(Reserve Bank) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">निर्देश</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 2016 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">होगा जो समय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समय पर संशोधित</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">संशोधित या अद्यतन किया गया है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जो </span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">https://www.rbi.or</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">g</span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">.in/Scripts/BS_ViewMasDirections.asDx?id= 10598</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पर उपलब्ध है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन निर्देशों के प्रयोजन के लिए </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ग्राहक</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का तात्पर्य ऐसे </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">'</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">व्यक्ति</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">' </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">से है जिसने हमारे द्वारा प्रदान की गई सेवाओं या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मास्टर निर्देशों के तहत परिभाषित सेवाओं का लाभ उठाने के लिए हमारे साथ एक संविदात्मक व्यवस्था में प्रवेश किया है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">वित्तीय जानकारी</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का वही अर्थ होगा जो </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मास्टर निर्देशों में दिया गया है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसमें वित्तीय सूचना प्रदाता के पास उपलब्ध आपका वित्तीय डेटा शामिल है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">वित्तीय सूचना प्रदाता</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का अर्थ होगा बैंक</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बैंकिंग कंपनी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">गैर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बैंकिंग वित्तीय कंपनी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">परिसंपत्ति प्रबंधन कंपनी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">डिपॉजिटरी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">डिपॉजिटरी प्रतिभागी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बीमा कंपनी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बीमा रिपोजिटरी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पेंशन फंड</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या ऐसी अन्य इकाई जिसे </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मास्टर निर्देशों में </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">वित्तीय सूचना प्रदाता</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">के रूप में पहचाना जा सकता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">वित्तीय सूचना प्रयोक्</span>
                </b>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">
                        <font face="Anek Devanagari">&#8205;</font>
                    </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का अर्थ किसी वित्तीय क्षेत्र विनियामक के साथ पंजीकृत और उसके द्वारा विनियमित इकाई</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या ऐसी अन्य इकाई होगी जिसे </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मास्टर निर्देशों में </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वित्तीय सूचना प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">के रूप में पहचाना जा सकता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">वित्तीय क्षेत्र विनियामक</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का वही अर्थ होगा जो </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मास्टर निर्देशों में दिया गया है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">व्यक्तिगत जानकारी</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">व्यक्तिगत डेटा</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का अर्थ किसी व्यक्ति के बारे में कोई डेटा है जो ऐसे डेटा से या उसके संबंध में पहचाना जा सकता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (h)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">RBI</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का तात्पर्य </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">होगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">Sandbox</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का तात्पर्य प्लेटफॉर्म पर उपलब्ध परीक्षण वातावरण से है जो वित्तीय सूचना प्रदाता और वित्तीय सूचना प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता को हमारी पेशकश का आकलन करने की अनुमति देता है।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">नियमों के अंतर्गत जो शब्द बड़े अक्षरों में लिखे गए हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">लेकिन इस खंड </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">1 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">में परिभाषित नहीं हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">उनका अर्थ वही होगा जो विशिष्ट खंड में दिया गया है।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        2.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">दायरा</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">खाता एकत्रीकरण सेवाएँ</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">": </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्लेटफ़ॉर्म के माध्यम से</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l9 level1 lfo4;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वित्तीय सूचना प्रदाताओं के पास उपलब्ध वित्तीय सूचना को पुनः प्राप्त कर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">देख</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समेकित कर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">व्यवस्थित कर और साझा कर सकते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तथा</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l9 level1 lfo4;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अपनी वित्तीय जानकारी वित्तीय सूचना प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ताओं को प्रस्तुत करें।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्लेटफ़ॉर्म के माध्यम से हमारे द्वारा प्रदान की जाने वाली खाता एकत्रीकरण सेवाओं के साथ</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">साथ ग्राहक को प्लेटफ़ॉर्म तक पहुंच के प्रावधान को </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाएं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कहा जाएगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमें आपको सेवाएं प्रदान करने के लिए</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप हमें इन शर्तों के खंड </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">6 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">के अनुसार आपकी सहमति से</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वित्तीय सूचना प्रदाताओं से आपकी वित्तीय जानकारी तक पहुंचने और बदले में इसे आपकी आवश्यकता के अनुसार वित्तीय सूचना प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ताओं के साथ साझा करने के लिए सीमित शक्ति के साथ अपने एजेंट के रूप में अधिकृत और नियुक्त करते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.0500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम लागू कानूनों के अनुसार आपसे सेवाओं के लिए शुल्क लेने का अधिकार सुरक्षित रखते हैं। यदि हम सेवाओं के लिए शुल्क लेना चाहते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो शुल्क हमारे प्लेटफॉर्म पर उपलब्ध मूल्य निर्धारण नीति के अनुरूप होगा। इसके अतिरिक्त</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">भविष्य में कोई भी शुल्क भावी आधार पर लगाया जाएगा और आपको इस मामले में पूर्व लिखित सूचना दी जाएगी।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रोफ़ाइल निर्माण</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं का लाभ उठाने के लिए</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपको प्लेटफ़ॉर्म पर एक प्रोफ़ाइल </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रोफ़ाइल</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बनानी होगी। प्रोफ़ाइल बनाने के लिए प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता नाम और पासवर्ड सेट करने के अलावा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपको कुछ विवरण प्रदान करने की आवश्यकता होगी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसमें नाम</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ईमेल पता और फ़ोन नंबर शामिल हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">लेकिन यह इन तक ही सीमित नहीं है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जैसा कि लागू कानूनों द्वारा आवश्यक हो सकता है। आप वारंट करते हैं कि आपके प्रोफ़ाइल के संबंध में दी गई सभी जानकारी सटीक और सत्य है और रहेगी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और आप सहमत हैं कि इस जानकारी में किसी भी परिवर्तन या संशोधन की स्थिति में आप प्लेटफ़ॉर्म पर अपने विवरण को तुरंत अपडेट करेंगे।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप अपने </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हैंडल</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता नाम और पासवर्ड की सुरक्षा और गोपनीयता बनाए रखने के लिए पूरी तरह से जिम्मेदार हैं और अपनी प्रोफ़ाइल के संबंध में किसी भी प्रकटीकरण या अनधिकृत उपयोग या सुरक्षा के किसी अन्य उल्लंघन के बारे में हमें तुरंत सूचित करने के लिए सहमत हैं। आप </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(i) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमें तुरंत रिपोर्ट करेंगे और सेवाओं के किसी भी अनधिकृत उपयोग को रोकने के लिए उचित प्रयास करेंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसके बारे में आपको पता है या संदेह है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ii) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं तक पहुंच प्राप्त करने या उनका उपयोग करने के लिए गलत पहचान जानकारी प्रदान नहीं करेंगे। </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">AA </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">हैंडल</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का अर्थ है हमारे प्लेटफ़ॉर्म पर आपके पंजीकरण के समय उत्पन्न एक अद्वितीय पहचानकर्ता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसका उपयोग पार्टियों द्वारा प्लेटफ़ॉर्म तक पहुंचने और सेवाएं प्रदान करने के लिए किया जाता है।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप स्पष्ट रूप से अपनी प्रोफ़ाइल के माध्यम से होने वाली सभी गतिविधियों के लिए उत्तरदायी और जवाबदेह होने के लिए सहमत हैं। हम किसी भी तरह से आपकी प्रोफ़ाइल तक किसी भी अनधिकृत पहुंच के लिए उत्तरदायी नहीं होंगे। आपके अनुचित उपयोग के कारण प्रत्यक्ष या अप्रत्यक्ष रूप से हुई डेटा या कार्यक्षमता की किसी भी हानि के लिए हम उत्तरदायी नहीं होंगे।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;text-indent:7.0000pt;
tab-stops:left blank 21.1500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l7 level2 lfo6;">
                <![if !supportLists]>
                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.1<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमें प्लेटफॉर्म के उन प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ताओं के संबंध में कुछ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अपने ग्राहक को जानें</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रक्रियाएं शुरू करने की आवश्यकता हो सकती है जो सेवाओं की कुछ विशेषताओं का लाभ उठाने का इरादा रखते हैं। </span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप हमें और हमारे साथ जुड़े किसी भी तृतीय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पक्ष सेवा प्रदाता को आपके </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">दस्तावेजों को संसाधित करने और आपकी पात्रता सुनिश्चित करने के लिए अधिकृत करते हैं। हमारे द्वारा की जाने वाली कोई भी प्रक्रिया हमारी गोपनीयता नीति के अनुसार होगी। आप सहमत हैं कि यदि कोई तीसरा पक्ष इस खंड के अंतर्गत जानकारी संसाधित करता है तो आप सेवा की अतिरिक्त शर्तों के अधीन हो सकते हैं। इसके अलावा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि पात्रता निर्धारित करने के लिए किसी अतिरिक्त जानकारी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">डेटा या दस्तावेज़ीकरण की आवश्यकता होती है </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सामूहिक रूप से</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, "</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">अतिरिक्त जानकारी</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"), </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आप अनुरोध किए जाने पर ऐसी अतिरिक्त जानकारी को तुरंत साझा करने के लिए सहमत होते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और इसके अलावा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमें ऐसी अतिरिक्त जानकारी को संसाधित करने के लिए अधिकृत करते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप सत्य</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पूर्ण और अद्यतन </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">दस्तावेज और अतिरिक्त जानकारी प्रदान करने के लिए सहमत और वारंट हैं। आप यह भी स्वीकार करते हैं कि </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(i) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इस संबंध में प्रदान की गई कोई भी गलत या भ्रामक जानकारी इन शर्तों का भौतिक उल्लंघन मानी जाएगी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ii) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि आप </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">दस्तावेज़ और अतिरिक्त जानकारी साझा करने में विफल रहते हैं तो सेवाओं की कुछ सुविधाओं तक आपकी पहुँच सीमित या अस्वीकृत की जा सकती है।</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;text-indent:7.0000pt;
tab-stops:left blank 21.1500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l7 level2 lfo6;">
                <![if !supportLists]>
                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.2<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">डेटा उपयोग करने की सहमति</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम आपकी किसी भी वित्तीय जानकारी को संग्रहीत</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">एक्सेस या देखते नहीं हैं। </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ReBIT (Reserve Bank Information Technology Private Limited) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">द्वारा परिभाषित </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">NBFC-AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तकनीकी विनिर्देशों के अनुसार</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम आपकी </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रोफाइल बनाने और आपके वित्तीय खातों की खोज में आपकी सहायता करने के लिए आपका मोबाइल नंबर एकत्र और सत्यापित करते हैं। आपकी सहमति से संबंधित गतिविधियों के बारे में </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">SMS </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सूचनाएं भेजने के लिए आपका मोबाइल नंबर एन्क्रिप्टेड प्रारूप में सुरक्षित रूप से संग्रहीत किया जाता है। इसके अतिरिक्त</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि कोई </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">FIP </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ऐसा चाहता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आपके </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">PAN </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और जन्मतिथि को </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Finvu AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रणाली के माध्यम से मास्क्ड फॉर्म में </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ReBIT </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">द्वारा प्रकाशित </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">NBFC-AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तकनीकी विनिर्देशों के अनुसार</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">भेजा जाता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ताकि </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">FIP </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">को लिंक किए गए सटीक खातों का पता लगाने में मदद मिल सके। </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Finvu AA </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">में </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">PAN </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और जन्मतिथि बिल्कुल भी संग्रहीत नहीं होती।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 19.0500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमारी सेवाओं का प्रावधान आपको अपनी वित्तीय जानकारी के प्रकटीकरण और हस्तांतरण के लिए अपनी सहमति प्रदान करने में सक्षम बनाता है। सहमति एक सहमति आर्टिफैक्ट के उपयोग के माध्यम से एकत्रित और पुष्टि की जाती है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसके लिए आपको निम्नलिखित डेटासेट की पुष्टि करनी होगी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 22.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपकी पहचान और वैकल्पिक संपर्क जानकारी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 23.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अनुरोधित वित्तीय जानकारी की प्रकृति</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ऐसी जानकारी एकत्र करने का उद्देश्य</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 212.75pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सूचना प्राप्तकर्ताओं की पहचान</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 23.3000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">URL </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या अन्य पता जिस पर सूचना तक पहुंचने के लिए सहमति आर्टिफैक्ट का उपयोग किए जाने पर हर बार अधिसूचना भेजने की आवश्यकता होती है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सहमति निर्माण तिथि</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सहमति की समाप्ति की तिथि और आपका हस्ताक्षर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">डिजिटल हस्ताक्षर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कोई अन्य जानकारी जो लागू कानून के अंतर्गत आवश्यक हो सकती है।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप किसी भी समय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपसे संबंधित कोई भी वित्तीय जानकारी प्राप्त करने के लिए सहमति पत्र के माध्यम से हमें प्रदान की गई अपनी सभी या किसी भी सहमति को रद्द कर सकते हैं। निरस्तीकरण के पश्चात</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वित्तीय सूचना प्रदाता और वित्तीय सूचना प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता को ऐसी अधिसूचना के बारे में सूचित किया जाएगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:7.0000pt;tab-stops:left blank 18.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप किसी भी समय आपके और वित्तीय सूचना प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ताओं द्वारा प्रदान की गई सहमति के रिकॉर्ड तक पहुंच सकते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिनके साथ प्लेटफॉर्म पर जानकारी साझा की गई है।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप सहमत हैं कि हम अपनी गोपनीयता नीति के अनुसार आपकी व्यक्तिगत जानकारी और तकनीकी डेटा तथा संबंधित जानकारी एकत्रित कर सकते हैं और उसका उपयोग कर सकते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 17.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम प्लेटफ़ॉर्म की प्रभावशीलता और दक्षता को और बढ़ाने के लिए विश्लेषण</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रवृत्तियों की पहचान और सांख्यिकी के लिए प्लेटफ़ॉर्म में सेवाओं और गतिविधियों के आपके उपयोग से संबंधित वित्तीय जानकारी और डेटा को छोड़कर जानकारी का उपयोग कर सकते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:7.0000pt;
tab-stops:left blank 18.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">लागू कानूनों के अधीन</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमें कानून प्रवर्तन एजेंसियों या सरकार और संबंधित नियामक निकायों द्वारा आपराधिक कार्यवाही या किसी अन्य कार्यवाही के संबंध में आपसे संबंधित डेटा का खुलासा करने का निर्देश दिया जा सकता है। आप समझते हैं और सहमत हैं कि ऐसे मामलों में</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमें ऐसे डेटा को संबंधित एजेंसियों या निकायों के साथ साझा करने का अधिकार होगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        4.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">अधिसूचनाएं</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप समझते हैं कि कंपनी आपको समय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समय पर आपके पंजीकृत ईमेल आईडी या फोन नंबर पर नोटिस</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">संचार या अलर्ट भेज सकती है और आप उन आवश्यक संचारों से ऑप्ट</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आउट करने में सक्षम नहीं हो सकते हैं जो सेवाओं के प्रावधान के लिए आवश्यक हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि आपने अलर्ट या संचार की प्राप्ति को अक्षम कर दिया है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो कंपनी आपको इसे संशोधित करने और सेवाओं के इष्टतम उपयोग के लिए अलर्ट की प्राप्ति को उसके उचित गंतव्य पर सक्रिय करने की सलाह देती है।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कंपनी की ओर से संचार केवल सेवाओं से संबंधित होगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        5.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमारे दायित्व</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम आपकी स्पष्ट सहमति के आधार पर आपको सेवाएं प्रदान करेंगे।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम यह सुनिश्चित करेंगे कि आपको प्रदान की जाने वाली सेवाओं के समर्थन में हमारे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपके और वित्तीय सूचना प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ताओं के बीच उचित समझौते और</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या प्राधिकरण हों।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम आपसे संबंधित कोई भी वित्तीय जानकारी संग्रहीत नहीं करते हैं और जिसे हम सेवाओं के संबंध में संसाधित कर सकते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम खाता एकत्रीकरण का व्यवसाय करने के लिए किसी तीसरे पक्ष के सेवा प्रदाता की सेवाओं का उपयोग नहीं करेंगे।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम विभिन्न वित्तीय सूचना प्रदाताओं के खातों से संबंधित आपके प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता प्रमाणीकरण क्रेडेंशियल तक पहुंच नहीं बनाएंगे।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        6.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपके उत्तरदायित्व</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप प्रतिनिधित्व करते हैं और वारंटी देते हैं कि सेवाओं के माध्यम से या उनके संबंध में प्रदान की गई सभी जानकारी इन शर्तों से सहमत होने की तिथि पर पूर्ण</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सत्य और सही है और जब तक आप सेवाओं का लाभ उठाते हैं तब तक यह पूर्ण</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सत्य और सही बनी रहेगी। यदि इन शर्तों के अस्तित्व के दौरान आपके द्वारा प्रदान की गई कोई भी जानकारी बदल जाती है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आप तुरंत इस परिवर्तन को हमारे ध्यान में लाने और अपनी प्रोफ़ाइल के माध्यम से इसे तुरंत अपडेट करने का वचन देते हैं। आप स्वीकार करते हैं कि हम प्लेटफ़ॉर्म के माध्यम से आपके द्वारा प्रेषित जानकारी की सामग्री पर कोई नियंत्रण नहीं रखते हैं। यदि सेवाओं का लाभ उठाने के लिए प्रदान की गई कोई जानकारी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">दस्तावेज</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सामग्री या डेटा गलत</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अपूर्ण</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अशुद्ध या भ्रामक है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या यदि आप कोई भी महत्वपूर्ण तथ्य प्रकट करने में विफल रहते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आपको होने वाले किसी भी नुकसान या क्षति के लिए हम कोई जिम्मेदारी या दायित्व स्वीकार नहीं करते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप लागू कानूनों के अनुपालन को सुनिश्चित करने के लिए पूरी तरह से जिम्मेदार होंगे और इस संबंध में आपके दायित्वों के उल्लंघन के कारण उत्पन्न होने वाली किसी भी देयता के लिए पूरी तरह से उत्तरदायी होंगे।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों के अंतर्गत आपके दायित्वों या अनुबंधों के उल्लंघन के कारण हमारे विरुद्ध शुरू की जाने वाली किसी भी कार्यवाही के बचाव में आपको हमें पूरा सहयोग देना होगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        7.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">निषिद्ध गतिविधियाँ</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l13 level1 lfo13;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप इन शर्तों में स्पष्ट रूप से अनुमति दिए जाने के अलावा किसी भी तरीके से सेवाओं का उपयोग नहीं करेंगे। पूर्ववर्ती वाक्य की व्यापकता को सीमित किए बिना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप निम्न कार्य नहीं करेंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कॉपी करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">संशोधित करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अनुकूलित करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अनुवाद करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">रिवर्स इंजीनियर करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">डीकंपाइल करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अलग करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बदलना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पुनरुत्पादित करना या अन्यथा प्लेटफ़ॉर्म में कोई भी परिवर्तन करना या कोई व्युत्पन्न कार्य बनाना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तीसरे पक्ष को समय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">साझाकरण</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बेंचमार्किंग या अन्य कंप्यूटर सेवाएं प्रदान करने के लिए किसी भी तरह से प्लेटफॉर्म का उपयोग करें</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सिवाय यहां स्पष्ट रूप से दिए गए के</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी तीसरे पक्ष को प्लेटफॉर्म की कार्यक्षमता तक पहुंचने या उससे लाभ उठाने की अनुमति दें</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या किसी प्रतिस्पर्धी या समान उत्पाद को विकसित करने के लिए प्लेटफॉर्म का उपयोग करें।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं का उपयोग किसी भी डेटा को प्रसारित करने या किसी भी सामग्री को भेजने या अपलोड करने के लिए करना जिसमें वायरस</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ट्रोजन हॉर्स</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वर्म्स</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">टाइमबॉम्ब</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कीस्ट्रोक लॉगर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">स्पाइवेयर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">एडवेयर या कोई अन्य हानिकारक प्रोग्राम या समान कंप्यूटर कोड शामिल हो जो किसी भी कंप्यूटर सॉफ़्टवेयर या हार्डवेयर के संचालन को प्रतिकूल रूप से प्रभावित करने या किसी भी कंप्यूटर संसाधन की कार्यक्षमता को नष्ट या सीमित करने के लिए डिज़ाइन किया गया हो</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्लेटफ़ॉर्म या उसके किसी भाग की निगरानी या प्रतिलिपि बनाने के लिए किसी रोबोट</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">स्पाइडर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अन्य स्वचालित डिवाइस या मैन्युअल प्रक्रिया का उपयोग करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी पेटेंट</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ट्रेडमार्क</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कॉपीराइट या अन्य मालिकाना अधिकारों का उल्लंघन करता है</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी व्यक्ति या संस्था का प्रतिरूपण या गलत प्रस्तुतिकरण करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसमें व्यक्ति</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अधिकारी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">निदेशक</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कर्मचारी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">एजेंट</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अधिकृत प्रतिनिधि</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">फोरम नेता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मार्गदर्शक या मेजबान शामिल हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">लेकिन इन्हीं तक सीमित नहीं हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या किसी भी जानकारी या खाते को गलत तरीके से प्रस्तुत करना या अन्यथा गलत तरीके से प्रस्तुत करना।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 13.9500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">संदेश के उद्गम के बारे में प्राप्तकर्ता को धोखा देता है या गुमराह करता है या जानबूझकर और जानबूझकर कोई गलत सूचना या जानकारी संप्रेषित करता है जो स्पष्ट रूप से झूठी और असत्य या भ्रामक प्रकृति की है या</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">केंद्र सरकार के किसी भी व्यवसाय के संबंध में</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">केंद्र सरकार की ऐसी तथ्य जांच इकाई द्वारा नकली या झूठी या भ्रामक के रूप में पहचाना जाता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसे मंत्रालय आधिकारिक राजपत्र में प्रकाशित अधिसूचना द्वारा निर्दिष्ट कर सकता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 15.1500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (viii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">भारत की एकता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अखंडता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">रक्षा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सुरक्षा या संप्रभुता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">विदेशी राज्यों के साथ मैत्रीपूर्ण संबंधों या सार्वजनिक व्यवस्था को खतरा पहुंचाता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या किसी संज्ञेय अपराध के लिए उकसाता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या किसी अपराध की जांच को रोकता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या अन्य राष्ट्र का अपमान करता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ix)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी अन्य व्यक्ति का प्रतिरूपण करना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (x)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इसमें सॉफ़्टवेयर वायरस या कोई अन्य कंप्यूटर कोड</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">फ़ाइल या प्रोग्राम शामिल है जिसे बाधित करने के लिए डिज़ाइन किया गया है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रत्यक्ष या अप्रत्यक्ष रूप से संग्रह</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">संकलन</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">डेटाबेस या निर्देशिका बनाने या संकलित करने के लिए प्लेटफ़ॉर्म से सामग्री की व्यवस्थित पुनर्प्राप्ति में संलग्न होना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 13.9500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं का उपयोग </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(A) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी गैरकानूनी तरीके से</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, (B) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">धोखाधड़ी या दुर्भावनापूर्ण गतिविधियों के लिए</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(C) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों के साथ असंगत किसी भी तरीके से</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 15.1500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xiii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी तरह से लागू कानूनों का उल्लंघन न करें।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l12 level1 lfo15;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप वारंट करते हैं कि आप किसी भी ऐसी गतिविधि में शामिल नहीं होंगे जो प्लेटफ़ॉर्म तक पहुंच में हस्तक्षेप या बाधा उत्पन्न करती हो।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l12 level1 lfo15;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप हैकिंग</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पासवर्ड माइनिंग या किसी अन्य अवैध तरीके से प्लेटफ़ॉर्म के किसी भी भाग या सुविधा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्लेटफ़ॉर्म से जुड़े किसी अन्य सिस्टम या नेटवर्क</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमारे किसी भी सर्वर या प्लेटफ़ॉर्म के माध्यम से अनधिकृत पहुंच प्राप्त करने का प्रयास नहीं करेंगे।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        8.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">बौद्धिक संपत्ति</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्लेटफ़ॉर्म</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">से उत्पन्न होने वाले सभी बौद्धिक संपदा अधिकारों सहित प्लेटफ़ॉर्म</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">में सभी अधिकार</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">शीर्षक और हित हमारे स्वामित्व में हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या अन्यथा हमें लाइसेंस प्राप्त हैं। इन शर्तों के अनुपालन के अधीन</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम आपको इन शर्तों और समय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समय पर जारी किए गए लिखित निर्देशों के अनुसार प्लेटफ़ॉर्म</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का उपयोग करने के लिए एक गैर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अनन्य</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">गैर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हस्तांतरणीय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">गैर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">उप</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">लाइसेंस योग्य</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">रॉयल्टी मुक्त</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रतिसंहरणीय और सीमित लाइसेंस प्रदान करते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.0500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम आपसे समय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समय पर प्लेटफ़ॉर्म या सेवाओं से संबंधित बग रिपोर्ट सहित सुझाव और अन्य फीडबैक प्रस्तुत करने का अनुरोध कर सकते हैं </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">फीडबैक</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">")</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">। आप हमें इस प्रकार के फीडबैक पर सभी अधिकार</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">शीर्षक और हित सौंपते हैं तथा इस प्रकार के फीडबैक के आधार पर कोई भी विकास करने का विशेष अधिकार प्रदान करते हैं। हम फीडबैक का स्वतंत्र रूप से उपयोग</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रतिलिपि</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रकटीकरण</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रकाशन</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रदर्शन</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वितरण और शोषण कर सकते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों में बताए गए को छोड़कर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों में किसी भी बात को हमारे या किसी तीसरे पक्ष के बौद्धिक संपदा अधिकारों में कोई अधिकार या लाइसेंस प्रदान करने के रूप में नहीं समझा जाना चाहिए।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        9.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">अवधि और समापन</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ये शर्तें तब तक प्रभावी रहेंगी जब तक कि इन्हें नीचे दी गई शर्तों के अनुसार समाप्त नहीं कर दिया जाता।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.0500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि आप इन शर्तों के तहत किसी भी दायित्व</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिम्मेदारी या अनुबंध का उल्लंघन करते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या जब आप हमारी सेवाओं या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का प्रयोक्</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Devanagari">&#8205;</font>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ता बनना बंद कर देते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो हम अपने विवेक पर तुरंत और किसी भी समय सेवाओं या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या उसके किसी भी हिस्से तक आपकी पहुंच या उपयोग को समाप्त कर सकते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों की समाप्ति पर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्रोफ़ाइल समाप्त हो जाएगी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाएँ </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समय</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समाप्त</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हो जाएँगी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ये शर्तें समाप्त हो जाएंगी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सिवाय उन खंडों के जो स्पष्ट रूप से समाप्ति या समाप्ति के बाद भी बने रहने का इरादा रखते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 13.0000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        10.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">अस्वीकरण और वारंटी</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम सेवाओं और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पर या उनके माध्यम से उपलब्ध कराई गई किसी भी वित्तीय जानकारी की सटीकता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">उपयुक्तता या शुद्धता की गारंटी नहीं देते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.0500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्लेटफ़ॉर्म</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाएँ और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">SANDBOX </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमारे द्वारा </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जैसा है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आधार पर किसी भी प्रकार की वारंटी के बिना प्रदान किए जाते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">व्यक्त</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">निहित</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वैधानिक या अन्यथा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसमें शीर्षक</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">गैर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">उल्लंघन</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">व्यापारिकता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या किसी विशेष उद्देश्य के लिए उपयुक्तता की निहित वारंटी शामिल हैं। हम इस बात की गारंटी नहीं देते कि सेवाएँ या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपके अनुप्रयोगों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या आपके द्वारा प्रदान किए गए किसी अन्य हार्डवेयर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सॉफ़्टवेयर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सिस्टम या डेटा के साथ मिलकर काम करेंगे। आप स्वीकार करते हैं कि हम इंटरनेट सहित संचार सुविधाओं पर डेटा के हस्तांतरण को नियंत्रित नहीं करते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और ये सेवाएं ऐसी संचार सुविधाओं के उपयोग में निहित सीमाओं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">देरी और अन्य समस्याओं के अधीन हो सकती हैं। पूर्वोक्त को सीमित किए बिना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम कोई वारंटी नहीं देते हैं कि</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.3500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l22 level1 lfo20;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्लेटफ़ॉर्म</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">में निहित कार्य आपकी आवश्यकताओं या अपेक्षाओं को पूरा करेंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या सेवाओं या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का आपका उपयोग निर्बाध</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समय पर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सुरक्षित या त्रुटि</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मुक्त होगा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l22 level1 lfo20;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">प्लेटफ़ॉर्म में किसी भी त्रुटि या दोष को ठीक किया जाएगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपके द्वारा हमसे प्राप्त कोई भी सलाह या जानकारी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">चाहे मौखिक हो या लिखित</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी प्रकार की वारंटी का निर्माण नहीं करेगी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जो शर्तों में स्पष्ट रूप से नहीं बताई गई है।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप सेवाओं और </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">के आपके उपयोग से उत्पन्न होने वाले किसी भी परिणाम के लिए पूर्ण जिम्मेदारी स्वीकार करते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और स्पष्ट रूप से सहमत हैं और स्वीकार करते हैं कि इस संबंध में हमारी कोई जिम्मेदारी नहीं होगी।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप यह समझते हैं कि वित्तीय सूचना प्रदाता से मांगी गई कुछ वित्तीय जानकारी प्रसंस्करणाधीन हो सकती है या उसमें वास्तविक समय की जानकारी नहीं हो सकती है </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जैसे डीमैट फोलियो के लिए</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और इसलिए वह उचित रूप से प्रतिबिंबित नहीं हो सकती है। इसे हमारी सेवाओं में कमी के रूप में नहीं समझा जाना चाहिए और तदनुसार हमारे द्वारा दी गई जानकारी पर भरोसा किया जाना चाहिए।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 10.8500pt ;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कानून द्वारा अनुमत अधिकतम सीमा तक</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमारे सहयोगी और संबंधित पक्ष निम्नलिखित के कारण या उससे उत्पन्न होने वाली किसी भी हानि या क्षति के लिए आपके प्रति सभी उत्तरदायित्वों से इनकार करते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(i) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style="mso-tab-count:1"></span>
                </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आपके द्वारा किसी भी अस्वीकृति</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">डाउनटाइम</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">खराबी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">धोखाधड़ी या लापरवाही सहित सेवाओं या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का उपयोग</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">उपयोग करने में असमर्थता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या उपलब्धता या अनुपलब्धता।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं के लिए</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">से</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या उनके माध्यम से सूचना के संचालन या संचरण में किसी भी दोष</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">रुकावट</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या देरी की घटना या अस्तित्व</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">संचार विफलता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">चोरी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">विनाश या सेवाओं से संबंधित हमारे रिकॉर्ड</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कार्यक्रम</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सर्वर</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या अन्य बुनियादी ढांचे तक अनधिकृत पहुंच</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी समयावधि के लिए सेवाओं या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">का परिचालन में बने रहने में विफलता।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कोई भी अप्रत्याशित घटना।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अनुसूचित डाउनटाइम और अनिर्धारित डाउनटाइम</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 12.7500pt ;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">लागू कानून में परिवर्तन जो इन शर्तों को प्रभावित कर सकता है।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 13.7000pt ;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ग्राहक द्वारा सहमति रद्द करना।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यहां निहित किसी भी विपरीत बात के बावजूद</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">न तो हम और न ही हमारे सहयोगी या संबंधित पक्ष आपके या किसी तीसरे पक्ष के प्रति किसी भी अप्रत्यक्ष</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आकस्मिक</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">विशेष या परिणामी क्षति या राजस्व या लाभ की किसी भी हानि के लिए उत्तरदायी होंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जो किसी भी तरह से इन शर्तों या सेवाओं से प्रत्यक्ष या अप्रत्यक्ष रूप से या संबंधित रूप से उत्पन्न होती है। आप इस बात से सहमत हैं कि प्रत्यक्ष क्षति के लिए हमारी देयता </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">चाहे अनुबंध</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अपकृत्य </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">लापरवाही सहित</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">में हो</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">), </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कार्रवाई के रूप की परवाह किए बिना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 10,000 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">रुपये से अधिक नहीं होगी। उत्तरदायित्व की उपर्युक्त सीमाएं यहां किसी भी सीमित उपचार के आवश्यक उद्देश्य की विफलता के बावजूद लागू होंगी।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 12.0500pt ;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (h)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि आप </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तक पहुंचने के उद्देश्य से इस प्लेटफ़ॉर्म का उपयोग कर रहे हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आप समझते हैं कि हमारे पास </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">केवल आपके द्वारा हमारी पेशकशों के मूल्यांकन के लिए उपलब्ध है। किसी भी स्थिति में इसे वाणिज्यिक सेवा नहीं माना जाएगा। यदि आप हमारी पेशकशों की सदस्यता का उपयोग</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">लाभ उठाना चाहते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आप हमसे </span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">support@cookiejar.co.in</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पर संपर्क कर सकते हैं</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 13.2500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        11.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">मुआवज़ा</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;">
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप हमारे विकल्प पर क्षतिपूर्ति करेंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बचाव करेंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और हमें</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हमारी मूल कंपनी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सहायक कंपनियों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सहयोगियों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">समूह कंपनियों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">संयुक्त उद्यमों और उनके अधिकारियों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">कर्मचारियों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">निदेशकों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">एजेंटों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और प्रतिनिधियों को किसी भी दावे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मांग</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मुकदमे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">न्यायिक कार्यवाही</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हानि</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">देनदारियों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">क्षति और लागतों </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सीमा के बिना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सभी क्षति</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">देनदारियों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">निपटान</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">और वकीलों की फीस सहित</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">से सुरक्षित रखेंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जो प्लेटफ़ॉर्म तक आपकी पहुंच</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सेवाओं या </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">के उपयोग</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी कार्य</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">चूक</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">धोखाधड़ी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">लापरवाही या इन शर्तों के उल्लंघन या आपके या किसी तीसरे पक्ष द्वारा इन शर्तों के किसी भी उल्लंघन के कारण उत्पन्न होते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जो सेवाओं तक पहुंचने के लिए आपकी प्रोफ़ाइल का उपयोग कर सकते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 13.2500pt ;
mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        12.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">अधिकार क्षेत्र</span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                </b>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">शासकीय कानून और विवाद समाधान</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों को भारत के कानूनों के द्वारा नियंत्रित किया जाएगा और उन्हीं के अनुसार समझा और लागू किया जाएगा। इस खंड के अन्य प्रावधानों के अधीन</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">पुणे की अदालतों को इन शर्तों या सेवाओं के उपयोग से उत्पन्न होने वाले सभी मुद्दों पर विशेष अधिकार क्षेत्र होगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 12.0500pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों से उत्पन्न होने वाले किसी भी विवाद</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">टकराव</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मतभेद या मतभेद को वर्तमान में लागू मध्यस्थता और सुलह अधिनियम</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 1996 </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">के अनुसार पुणे में मध्यस्थता द्वारा हल किया जाएगा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसे इस खंड में संदर्भ द्वारा शामिल माना जाता है। मध्यस्थता की भाषा अंग्रेजी होगी।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मध्यस्थता में शामिल पक्ष मध्यस्थता को गोपनीय रखेंगे तथा आवश्यकता पड़ने पर या कानूनी सलाहकारों के अलावा किसी अन्य को इसका खुलासा नहीं करेंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जब तक कि कानून द्वारा ऐसा करना आवश्यक न हो। मध्यस्थ का निर्णय अंतिम होगा तथा सभी पक्षों पर बाध्यकारी होगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी विवाद के संबंध में मध्यस्थता में प्रत्येक पक्ष को अपनी लागत स्वयं वहन करनी होगी। आप </span>
                <u>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">ODR</span>
                </u>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">के माध्यम से भी कोई विवाद उठा सकते हैं</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 13.0000pt ;
mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        13.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">शिकायत निवारण</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि आप कोई शिकायत दर्ज कराना चाहते हैं तो कृपया वेबसाइट पर शिकायत विकल्प देखें।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी स्थिति में हम यह सुनिश्चित करेंगे कि आपकी शिकायत का समाधान शिकायत की तिथि से </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">30 (</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तीस</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">दिनों के भीतर हो जाए।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि शिकायत का निपटारा उक्त अवधि के भीतर नहीं होता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो आप नीचे दिए गए पते पर </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">RBI </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">से अपील कर सकते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <div align=center>
                <table class=MsoNormalTable border=0 cellspacing=0 style="border-collapse:collapse;mso-table-layout-alt:fixed;border:none;
mso-padding-alt:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;">
                    <tr style="height:16.3000pt;">
                        <td width=466 valign=center colspan=2 style="width:279.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 align=center style="margin-right:20.9000pt;margin-bottom:0.0000pt;text-align:center;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">मुंबई </span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">(</span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">क्षेत्रीय कार्यालय</span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">)</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.5500pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-right:1.9500pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">क्षेत्राधिकार</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">महाराष्ट्र राज्य और गोवा राज्य</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:15.8500pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-right:1.9500pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">पता</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">तीसरी मंजिल</span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, RBI </span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">बिल्डिंग</span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">मुंबई सेंट्रल रेलवे स्टेशन के सामने</span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">मराठा मंदिर के पास</span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">बायकुला</span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">मुंबई </span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">- 400 008</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.1000pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-right:1.9500pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">टेलीफ़ोन</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">022-2308 4121/2302 8436</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.3000pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-right:1.9500pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">फ़ैक्स</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=22 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">022-2302 2011</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.5500pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                            <p class=22 style="margin-right:1.9500pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ई</span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">-</span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">मेल</span>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                            <p class=22 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;">
                                    <a href="mailto:dnbsmro@rbi.or">dnbsmro@rbi.or</a>
                                </span>
                                <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(51,94,232);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">g</span>
                                <u>
                                    <span class="18" style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(51,94,232);
font-weight:normal;text-decoration:underline;text-underline:single;
font-style:normal;font-variant:normal;font-size:12.75pt;">.in</span>
                                </u>
                                <span style="font-family:'Anek Devanagari';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                </table>
            </div>
            <p class=MsoNormal style="margin-right:20.9000pt;margin-bottom:3.9500pt;">
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:'Courier New';
color:rgb(0,0,0);font-size:12.0000pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:9.0000pt;tab-stops:left blank 13.0000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:bold;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        14.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">विविध प्रावधान</span>
                </b>
                <b>
                    <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-size:12.75pt;">
                        <o:p></o:p>
                    </span>
                </b>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">संशोधन</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम किसी भी समय इन शर्तों को संशोधित करने और सेवाओं के उपयोग पर नई या अतिरिक्त शर्तें जोड़ने का अधिकार सुरक्षित रखते हैं। ऐसे संशोधन और अतिरिक्त नियम व शर्तें आपको सूचित कर दी जाएंगी और जब तक स्पष्ट रूप से अस्वीकार न कर दिया जाए </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिससे ये शर्तें समाप्त हो जाएंगी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">), </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">वे तुरंत प्रभावी होंगी और इन शर्तों में शामिल कर ली जाएंगी। यदि आप ऐसे परिवर्तनों को स्वीकार करने से इनकार करते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो ये शर्तें समाप्त हो जाएंगी।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">पृथकता</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि इन शर्तों के किसी प्रावधान को किसी न्यायालय या अन्य सक्षम प्राधिकारी द्वारा गैरकानूनी या अप्रवर्तनीय पाया जाता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो इन शर्तों के अन्य प्रावधान प्रभावी रहेंगे। यदि कोई गैरकानूनी या अप्रवर्तनीय प्रावधान</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि उसका कोई भाग हटा दिया जाए</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो वह वैध या प्रवर्तनीय हो सकता है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो उस भाग को हटा दिया गया माना जाएगा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तथा प्रावधान का शेष भाग प्रभावी बना रहेगा </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जब तक कि वह खंड के स्पष्ट आशय का खंडन न करे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ऐसी स्थिति में प्रासंगिक प्रावधान की संपूर्णता को हटा दिया गया माना जाएगा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">)</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">कार्यभार</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">आप हमारी पूर्व लिखित सहमति के बिना किसी भी तरीके से इन शर्तों के तहत अपने अधिकारों</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">दायित्वों या अनुबंधों को लाइसेंस नहीं देंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">बेचेंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">स्थानांतरित नहीं करेंगे या सौंपेंगे नहीं। हम अपने पूर्ण विवेक के आधार पर तथा उचित समझी जाने वाली किसी भी शर्त के अधीन यह सहमति दे सकते हैं या रोक सकते हैं। हम आपको कोई पूर्व सूचना दिए बिना अपने अधिकारों को हमारी किसी भी सहयोगी कंपनी</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">सहायक कंपनी या मूल कंपनी को</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">या सेवाओं से जुड़े किसी भी व्यवसाय के हित में किसी भी उत्तराधिकारी को सौंप सकते हैं।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">नोटिस</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">इन शर्तों के तहत हमारे लिए सभी सूचनाएं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अनुरोध</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">मांगें और निर्धारण </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">नियमित परिचालन संचार के अलावा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span>
                    <a href="mailto:info@cookiejar.co.in">
                        <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">info@cookiejar.co.in</span>
                    </a>
                </span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">&nbsp;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">को भेजे जाएंगे</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">तीसरे पक्ष के अधिकार</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी भी तीसरे पक्ष को इसमें निहित किसी भी शर्त को लागू करने का कोई अधिकार नहीं होगा।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.1000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">अप्रत्याशित घटना</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">यदि हम अपने दायित्वों को पूरा करने या अपने व्यवसाय को आगे बढ़ाने में किसी ऐसे कार्य</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">घटना</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">चूक या दुर्घटना के कारण बाधित होते हैं</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जो हमारे उचित नियंत्रण से परे है</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">तो हम आपके प्रति उत्तरदायी नहीं होंगे</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">जिसमें बिना किसी सीमा के</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हड़ताल</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">उपयोगिता सेवा या दूरसंचार नेटवर्क की विफलता</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">दैवीय कृत्य</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">युद्ध</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">दंगा</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">नागरिक उपद्रव</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">दुर्भावनापूर्ण क्षति</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">किसी कानून या सरकारी आदेश</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">नियम</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">विनियमन या निर्देश का अनुपालन शामिल है। </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">अप्रत्याशित घटना</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">")</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">अनुवाद</span>
                </b>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">हम आपको इन शर्तों को अधिक विस्तार से समझने में सहायता के लिए ही इनका अनूदित संस्करण उपलब्ध करा सकते हैं। इन शर्तों के अंग्रेजी संस्करण और किसी अनूदित संस्करण के बीच किसी भी असंगति की स्थिति में</span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">अंग्रेजी संस्करण की शर्तें ही मान्य होंगी।</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Devanagari';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
        </div>
        <!--EndFragment-->
    </body>
</html>
`,
};
